import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { url } from './../const';
import { environment } from 'src/environments/environment';
import { v4 } from 'uuid';
import { AuthService } from './auth.service';
@Injectable({
  providedIn: 'root'
})
export class ApiService {

  baseUrl = environment.url;

  constructor(private http: HttpClient, private auth:AuthService) { }

  authenticate(username: string,password: string) {
    return this.http.post(`${this.baseUrl}/users/authenticate`, { username, password });
  }

  authenticateOkta(email: string, appid:string ,token: string) {
    return this.http.post(`${this.baseUrl}/users/authenticateoktaaccess`, { username:email, token:appid, password:token });
  }

  getAnnouncements(){
    let user = this.auth.getUser();
    return this.http.post(`${this.baseUrl}/notifications/announcements`, {userId: user.userId});
  }

  getNotifications() {
    let user = this.auth.getUser();
    return this.http.post(`${this.baseUrl}/notifications/pushnotifications`, {userId: user.userId});
  }

  readNotification(notificationId: string) {
    let user = this.auth.getUser();
    let input = {userId: user.userId ,"pushNotificationId": notificationId,"pushNotificationStatus":"Read"}
    return this.http.post(`${this.baseUrl}/notifications/pushnotifications/updatestatus`, input);
  }

  readAnnouncement(announcementId: string) {
    let user = this.auth.getUser();
    let input = {userId: user.userId ,"announcementId": announcementId,"announcementStatus":"Read"}
    return this.http.post(`${this.baseUrl}/notifications/announcements/updatestatus`, input);
  }

  deleteNotification(notificationId: string) {
    let user = this.auth.getUser();
    let input = {userId: user.userId ,"pushNotificationId": notificationId, "pushNotificationStatus":"Deleted"}
    return this.http.post(`${this.baseUrl}/notifications/pushnotifications/updatestatus`, input);
  }

  deleteAnnouncement(announcementId: string) {
    let user = this.auth.getUser();
    let input = {userId: user.userId ,"announcementId": announcementId, "announcementStatus":"Deleted"}
    return this.http.post(`${this.baseUrl}/notifications/announcements/updatestatus`, input);
  }

  uploadFile(file: File, fileInfo: any) {
    let user = this.auth.getUser();

    const httpOptions = {
      reportProgress: true,
      observe: 'events' as 'events'
    };

    const formData = new FormData();

    formData.append('clientDocumentId', v4());
    formData.append('accountId', user.accountId);
    formData.append('userId', user.userId);
    formData.append('name', file.name);
    formData.append('type', file.type);
    formData.append('sha512', fileInfo.sha512);
    formData.append('toolName', 'TOOL_DROPLET_' + fileInfo.category.toUpperCase());
    formData.append('platform', 'darwin');
    formData.append('clientBatchId', fileInfo.batchId);
    formData.append('clientBatchCount', fileInfo.batchCount);
    formData.append('isSinglePersonBatch', fileInfo.isSinglePerson);
    formData.append('size', file.size.toString());
    formData.append('lastModified', file.lastModified.toString());
    formData.append('lastModifiedDate','2/28/2021, 10:31:07 AM');
    formData.append('file', file);
    
    return this.http.post(`${this.baseUrl}/documents/upload`, formData, httpOptions );

  }

  downloadFileBlob(url:string){
    return this.http.get(`${this.baseUrl}${url}`, {responseType: 'blob'});
  }

  downloadFileBlobExt(url:string){
    return this.http.get(`${url}`, {responseType: 'blob'});
  }

  fetchUserActivity() {
    let user = this.auth.getUser();
    let params = new HttpParams()
    .set('userId',  user.userId)
    .set('date', new Date().toISOString())
    .set('span', 'month')
    .set('scope', 'individual');
    return this.http.get(`${this.baseUrl}/dashboard/activity`, {params: params});
  }

  getRecentUploads(type: string) {
    let user = this.auth.getUser();
    let params = new HttpParams()
    .set('accountId',  user.accountId)
    .set('userId', user.userId)
    .set('toolName', type.toUpperCase() )
    .set('days', '30')
    .set('endDate', new Date().toISOString());
    return this.http.get(`${this.baseUrl}/documents/recent`, {params: params});
  }

  fetchLatestProdRelease(){
    return this.http.get('https://api.github.com/repos/YellowFolder/yf-tools-prod/releases/latest');
  }

  fetchLatestDevRelease(){
    return this.http.get('https://api.github.com/repos/YellowFolder/yf-tools-public/releases/latest');
  }
}
